export const APP_CONFIG = {
  MEMBERSHIP_ENABLED: false, // 🔴 turn ON/OFF here
};